<template>
	<page class="dashboard" title="Enheder" style="background-color: #F0F0F0;">
		<input class="tool-text" placeholder="Søg" type="text" slot="tools" v-model="search" />
		<button-view style="float: left;" slot="tools" @click="createClient">+ Ny</button-view>
		<button-view style="float: left;" slot="tools" @click="migrateClient">&gt; Migrer</button-view>
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'ID',
				name: 'id'
			},
			{
				label: 'Sidste pakke',
				name: 'lastMessageReceived',
				filter: 'timestamp'
			},
			{
				label: 'Version',
				name: 'version'
			},
			{
				label: 'Opdater til',
				name: 'versionTo'
			},
			{
				label: 'Note',
				name: 'note'
			},
			{
				label: 'Organisation',
				name: '_organisationString'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: '...'
				},
				weight: '100px'
			}
		]" :items="_items" @context="itemContext" @delete="itemContext" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

	import ContextPopupView from '../views/ContextPopupView';

	import client from '../model/client';

    export default {
		data() {
			return {
				search: '',
				items: []
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				const self = this;

				return (this.search == '' ? this.items : this.items.filter((item) => {
					const buffer = item.id + item.version + (item._organisation ? item._organisation.label.toLowerCase() : '');
					return buffer.indexOf(self.search) > -1;
				})).map(item => {
					return {
						...item,
						_organisationString: item._organisation ? `<span class="tag aqt_customer">${item._organisation.label}</span>` : null,
					};
				});
			}
		},
		methods: {
			createClient() {
				console.log("create client");

				const self = this;

				client.open(null, () => {
					self.update();
				});
			},
			migrateClient() {
				const self = this;

				client.openMigration(null, () => {
					self.update();
				});
			},
			async itemDelete(item, event) {
				event.stopPropagation();
				console.log('item delete', item);

				if (confirm('Sikker?')) {
					await this.axios.delete(`/clients/${item.id}`);
					this.update();
				}
			},
			createAction(item, template) {
				const self = this;

				return {
					label: template.label,
					action: async function () {
						//window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						client.send({
							id: item.id,
							topic: `clients/${item.id}`,
							tmpl: template.tmpl
						}, async (model) => {
							await self.axios.post('/publish', {
								topic: model.topic,
								payload: model.tmpl
							});

							return true;
						});
					}
				};
			},
			itemContext(item, event) {
				event.stopPropagation();
				console.log('context', item);

				var actions = [];

				if (item._organisation) {
					actions.push({
						label: `Fjern fra ${item._organisation.label}`,
						action: async () => {
							if (!confirm(`Fjern ${item.id} fra ${item._organisation.label}?`)) return;

							await this.axios.delete(`/devices/${item.id}/organisation`);
							this.update();
						}
					});
				}

				actions.push({
					label: '+ Organisation',
					action: async () => {
						client.assign(item.id, () => {
							this.update();
							return true;
						});
					}
				});

				actions.push(null);

				if (item.versionTo) {
					actions.push({
						label: 'Stop opdatering til ' + item.versionTo,
						action: async () => {
							await this.axios.delete(`/devices/${item.id}/update`);
							this.update();
						}
					});
				}

				actions.push({
					label: '+ Version',
					action: async () => {
						client.update(item.id, () => {
							this.update();
							return true;
						});
					}
				});

				actions.push(null);

				actions.push({
					label: 'Rediger',
					action: async () => {
						client.open(item.id, () => {
							this.update();
						});
					}
				});

				actions.push({
					label: 'Slet',
					action: async () => {
						if (!confirm('Sikker?')) return;

						await this.axios.delete(`/devices/${item.id}`);
						this.update();
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			async itemClick(item) {
				console.log('item click', item);
				const self = this;

				client.open(item.id, () => {
					self.update();
				});
			},
			async update() {
				this.items = (await this.axios.get('/devices?_size=1000')).data.content;
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}

	.list::v-deep {
		.tag {
			padding: 5px 10px;
			border-radius: 20px;
			color: white;
			font-size: 12px;
			white-space: nowrap;
		}

		.aqt_admin {
			background-color: #45a9f2;
		}

		.aqt_partner {
			background-color: #a36be2;
		}

		.aqt_customer {
			background-color: #61ce70;
		}

		.org_admin {
			background-color: rgb(206, 54, 54);
		}

		.org_caregiver {
			background-color: #e29842;
		}
	}
</style>